import { render, staticRenderFns } from "./InventoryFormFilters.vue?vue&type=template&id=f3068e92"
import script from "./InventoryFormFilters.vue?vue&type=script&lang=js"
export * from "./InventoryFormFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports